import { useCallback, useState } from 'react';

const useModal = (initialValue = null) => {
  const [value, setValue] = useState(initialValue);

  const open = useCallback(nextValue => {
    setValue(nextValue);
  }, []);

  const close = useCallback(() => {
    setValue(null);
  }, []);

  return {
    value,
    isOpen: value !== null,
    open,
    close,
  };
};

export default useModal;
